import { ContentRepository, Statuses } from "../commonTypes";
import { DateTime } from "luxon";

export type ExternalResourceStatus = Statuses;

export interface ExternalResource {
  title: string;
  url: string;
  headline: string;
  triggersNotification: boolean;
  photo: string;
  publicationDate: DateTime;
  removalDate: DateTime;
  id: string;
  status: ExternalResourceStatus;
}

export interface ExternalResourceLibrary
  extends ContentRepository<ExternalResource, ExternalResourceDTO> {}

export interface ExternalResourceDTO {
  title: string;
  url: string;
  image: File | undefined;
  imagePath?: string;
  headline: string;
  triggersNotification: boolean;
  publicationDate?: DateTime;
  removalDate?: DateTime;
  id?: string;
  status: ExternalResourceStatus;
}

export const EMPTY_EXTERNAL_RESOURCE: ExternalResource = {
  headline: "",
  id: "",
  triggersNotification: false,
  photo: "",
  publicationDate: DateTime.local().startOf("day"),
  removalDate: DateTime.local().endOf("day"),
  status: "draft",
  title: "",
  url: "",
};
